import { apiClient } from './client'

/**
 * Массовые операции над словами учителя и карточками учеников.
 *
 * Ошибка одного элемента не отменяет остальные: причины приходят в `details`,
 * счётчики отражают фактически применённые изменения.
 *
 * Через карточки не правятся теги и не собираются словари: и то и другое —
 * библиотека учителя (см. .cursor/rules/easya-tags-belong-to-words.mdc).
 */

export interface BulkOperationDetail {
  status: 'skipped' | 'failed'
  reason?: string
  word_id?: number
  card_id?: number
  student_id?: number
}

export interface BulkOperationResult {
  created: number
  updated: number
  skipped: number
  deleted: number
  failed: number
  details: BulkOperationDetail[]
}

interface BulkApiResponse {
  success?: boolean
  message?: string
  data?: BulkOperationResult
}

const EMPTY_RESULT: BulkOperationResult = {
  created: 0,
  updated: 0,
  skipped: 0,
  deleted: 0,
  failed: 0,
  details: [],
}

async function post(url: string, payload: Record<string, unknown>): Promise<BulkOperationResult> {
  const response = await apiClient.post<BulkApiResponse>(url, payload)
  return response.data?.data ?? EMPTY_RESULT
}

export const bulkApi = {
  /** Назначить слова словаря ученикам — у каждого появится карточка. */
  assignWordsToStudents: (payload: {
    word_ids: number[]
    student_ids: number[]
    skip_existing?: boolean
  }): Promise<BulkOperationResult> => post('/words/bulk-assign-to-students', payload),

  deleteCards: (cardIds: number[]): Promise<BulkOperationResult> =>
    post('/cards/bulk-delete', { card_ids: cardIds }),
}
